import React from 'react'

import classes from "./technology.module.scss";

const Technology = (props) => {
    return (  
        <span className={classes.Technology}>{props.children}</span>
    );
}
 
export default Technology;